import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPrePsychQuestionnaireData = {
    assets: ProcessActivityAsset[];
    toelichting: string | null;
};

export type BariPrePsychQuestionnaireReadKey = keyof BariPrePsychQuestionnaireData;
export type BariPrePsychQuestionnaireReadLabel = 'Vragenlijsten' | 'Toelichting';

export const bariPrePsychQuestionnaireReadSchema: TypedReadSchema<
    BariPrePsychQuestionnaireReadKey,
    BariPrePsychQuestionnaireReadLabel
>[] = [
    { items: [{ key: 'assets', label: 'Vragenlijsten' }] },
    { items: [{ key: 'toelichting', label: 'Toelichting' }] },
];

const bariPrePsychQuestionnaireFinal: TypedSchema<BariPrePsychQuestionnaireData> = {
    assets: getProcessActivityAssetsSchema({ min: 1 }),
    toelichting: getTextAreaStringSchema(true),
};

const bariPrePsychQuestionnaireDraft: TypedSchema<BariPrePsychQuestionnaireData> = {
    ...bariPrePsychQuestionnaireFinal,
    assets: getProcessActivityAssetsSchema(),
};

export const bariPrePsychQuestionnaireDraftSchema = Koi.object(bariPrePsychQuestionnaireDraft);
export const bariPrePsychQuestionnaireFinalSchema = Koi.object(bariPrePsychQuestionnaireFinal);
